var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"information"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row cont-top"},[_c('div',{staticClass:"col-md-6 col-sm-6 col-xs-12 offset-md-3",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }